import { createContext, useContext } from 'react'
import type { StagedAction } from './types'

export interface VisibleStagedActionsResult {
  stagedActions: Array<StagedAction>
  allActions: Array<StagedAction>
  isLoading: boolean
  isFetching: boolean
  hasFetched: boolean
}

/**
 * Leaf module on purpose: it must import nothing at runtime (types only), so no
 * hot update can ever re-execute it and recreate the context out from under
 * mounted consumers (which would make `useVisibleStagedActions` throw and trip
 * the overlay error boundary). Keep the provider (staged-actions-provider) and
 * the derivation logic (query.ts) out of this file.
 */
export const VisibleStagedActionsContext = createContext<VisibleStagedActionsResult | null>(null)

/**
 * The filtered + sorted list the sidepanel actually renders: drops archived /
 * manually-hidden / finished (non-live-shell) actions and sorts by recency.
 */
export function useVisibleStagedActions(): VisibleStagedActionsResult {
  const cached = useContext(VisibleStagedActionsContext)
  if (!cached) {
    throw new Error('useVisibleStagedActions must be used within StagedActionsProvider')
  }
  return cached
}
